module.exports = __webpack_public_path__ + "media/home/Home-ArtBook-30741a4b.jpg";